import ActionType from "../constants/ActionType";
import backendApiClient from "../api/backendApiClient";

function expiresAt(timeout: $TSFixMe) {
  if (timeout) {
    let expireAtTime = Date.now();
    expireAtTime += timeout * 1000;
    // we can not be sure to have the right time because of network delays
    // therefore we sustract a little buffer time of 10 seconds
    expireAtTime -= 10000;
    return expireAtTime;
  }
  return undefined;
}

export function initializeSession(session: $TSFixMe) {
  return {
    type: ActionType.INITIALIZE_SESSION,
    token: session.token,
    tokenExpiresAt: expiresAt(session.token_expires_in),
    sessionExpiresAt: expiresAt(session.session_expires_in),
    captchaRequired: session.captcha_required,
    activeSubscription: session.active_subscription,
    subscriptionType: session.subscription_type,
    subscriptionStatus: session.subscription_status,
    subscriptionAssetQuota: session.subscription_asset_quota,
    subscriptionSeatQuota: session.subscription_seat_quota,
    subscriptionOwnerId: session.subscription_owner_id,
    subscriptionStorageQuota: session.subscription_storage_quota,
    startUrl: session.start_url,
    applicationSpecifics: session.application_specifics,
    reseller: session.reseller,
    myEndressSsoLogoutUrl: session.myendress_sso_logout_url,
  };
}

export function refreshSessionFailed(errors: $TSFixMe) {
  return {
    type: ActionType.REFRESH_SESSION_FAILED,
    errors,
  };
}

export function createSessionFailed(errors: $TSFixMe) {
  return (dispatch: $TSFixMe) =>
    dispatch({
      type: ActionType.CREATE_SESSION_FAILED,
      errors,
    });
}

export function createSessionFetching() {
  return {
    type: ActionType.CREATE_SESSION_FETCHING,
  };
}

export function createSessionSuccessful(session: $TSFixMe) {
  return {
    type: ActionType.CREATE_SESSION_SUCCESSFUL,
    token: session.token,
    tokenExpiresAt: expiresAt(session.token_expires_in),
    sessionExpiresAt: expiresAt(session.session_expires_in),
    activeSubscription: session.active_subscription,
    subscriptionType: session.subscription_type,
    subscriptionStatus: session.subscription_status,
    subscriptionAssetQuota: session.subscription_asset_quota,
    subscriptionSeatQuota: session.subscription_seat_quota,
    subscriptionOwnerId: session.subscription_owner_id,
    subscriptionStorageQuota: session.subscription_storage_quota,
    startUrl: session.start_url,
    applicationSpecifics: session.application_specifics,
    reseller: session.reseller,
    myEndressSsoLogoutUrl: session.myendress_sso_logout_url,
  };
}

export function refreshSessionSuccessful(session: $TSFixMe) {
  return {
    type: ActionType.REFRESH_SESSION_SUCCESSFUL,
    token: session.token,
    tokenExpiresAt: expiresAt(session.token_expires_in),
    sessionExpiresAt: expiresAt(session.session_expires_in),
    activeSubscription: session.active_subscription,
    subscriptionType: session.subscription_type,
    subscriptionStatus: session.subscription_status,
    subscriptionAssetQuota: session.subscription_asset_quota,
    subscriptionSeatQuota: session.subscription_seat_quota,
    subscriptionOwnerId: session.subscription_owner_id,
    subscriptionStorageQuota: session.subscription_storage_quota,
    startUrl: session.start_url,
    applicationSpecifics: session.application_specifics,
    reseller: session.reseller,
    myEndressSsoLogoutUrl: session.myendress_sso_logout_url,
  };
}

export function createSession(
  email: $TSFixMe,
  password: $TSFixMe,
  captcha: $TSFixMe,
) {
  return (dispatch: $TSFixMe) => {
    dispatch(createSessionFetching());
    return backendApiClient()
      .post("/session", { email, password, captcha })
      .then((session) => dispatch(createSessionSuccessful(session)))
      .catch((errors) => dispatch(createSessionFailed(errors)));
  };
}

export function refreshSession() {
  return (dispatch: $TSFixMe) =>
    backendApiClient()
      // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
      .get("/session", { force_refresh: true })
      .then((session) => {
        dispatch(refreshSessionSuccessful(session));
      })
      .catch((errors) => {
        // TODO: This block will be removed after bug NDT-1816 is investigated
        /* istanbul ignore next */
        if (typeof errors === "object" && errors !== null) {
          // eslint-disable-next-line no-console
          console.error(JSON.stringify(errors, null, 2));
        } else {
          // eslint-disable-next-line no-console
          console.error(errors);
        }
        dispatch(refreshSessionFailed(errors));
      });
}

export function deleteSessionSuccessful() {
  return {
    type: ActionType.DELETE_SESSION_SUCCESSFUL,
  };
}

export function deleteSession() {
  return (dispatch: $TSFixMe) =>
    backendApiClient()
      // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
      .delete("/session")
      .then(() => dispatch(deleteSessionSuccessful()))
      // eslint-disable-next-line no-console
      .catch((errors) => console.error(errors));
}

export function sessionExpiredSuccessful() {
  return {
    type: ActionType.SESSION_EXPIRED,
  };
}

export function sessionExpired() {
  return (dispatch: $TSFixMe) =>
    backendApiClient()
      // @ts-expect-error TS(2554) FIXME: Expected 2-3 arguments, but got 1.
      .delete("/session")
      .then(() => dispatch(sessionExpiredSuccessful()))
      // eslint-disable-next-line no-console
      .catch((errors) => console.error(errors));
}
